import { render, staticRenderFns } from "./AgricultureXue.vue?vue&type=template&id=905429ee&scoped=true&"
import script from "./AgricultureXue.vue?vue&type=script&lang=js&"
export * from "./AgricultureXue.vue?vue&type=script&lang=js&"
import style0 from "./AgricultureXue.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AgricultureXue.vue?vue&type=style&index=1&id=905429ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905429ee",
  null
  
)

export default component.exports